const accordion = document.querySelectorAll(".Accordion");

if (accordion && accordion.length) {
  accordion.forEach((accordionInstance) => {
    const items = accordionInstance.querySelectorAll(".accordion__item");

    items.forEach((item) => {
      const title = item.querySelector(".accordion__title");

      title.addEventListener("click", () => {
        // Toggle current item
        toggle_item(item);
      });
    });

    const toggle_item = (item) => {
      const body = item.querySelector(".accordion__body");

      if (item.classList.contains("is-open")) {
        body.removeAttribute("style");
        item.classList.remove("is-open");
      } else {
        body.style.height = body.scrollHeight + "px";
        item.classList.add("is-open");
      }
      if (item.classList.contains("imagebar")) {
        body.classList.toggle("pb-96");
      }
    };
  });
}
